// const devApi = 'ltt'
// const locService = 'ltt'
const locService = 'locService'
const devApi = 'api'

const path = {
  apiName: devApi,
  php: '/shp',
  test: 'test',
  locService: locService
}

export default path
